import React from 'react';
import { NavLink } from 'react-router-dom';

import './index.css';

export default () => (
  <div className="footer">
    <div className="footer__content">
      <div className="footer__content__container">
        <div className="footer__content__wrapper">
            <div className="footer__name">Leo Trado</div>
            <NavLink to="/" className="footer__links">{localStorage.getItem('lang') == 'ru'? 'Главная':'Home'}</NavLink>
            <NavLink to="/mobile" className="footer__links">Mobile</NavLink>
            <NavLink to="/web" className="footer__links">Web</NavLink>
            <NavLink to="/portfolio" className="footer__links">{localStorage.getItem('lang') == 'ru'? 'Наши работы':'Our projects'}</NavLink>
            <NavLink to="/about" className="footer__links">{localStorage.getItem('lang') == 'ru'? 'O компании':'About us'}</NavLink>
            <NavLink to="/blog" className="footer__links">{localStorage.getItem('lang') == 'ru'? 'Блог':'Blog'}</NavLink>
            {/* <NavLink to="/vacancies" className="footer__links">{localStorage.getItem('lang') == 'ru'? 'Вакансии':'Vacancies'}</NavLink> */}
            <NavLink to="/contacts" className="footer__links">{localStorage.getItem('lang') == 'ru'? 'Контакты':'Contacts'}</NavLink>
            <NavLink to="/agreements" className="footer__links">{localStorage.getItem('lang') == 'ru'? 'Соглашения':'Agreements'}</NavLink>
            <NavLink to="/usage" className="footer__links footer__links__bottom footer__links__shot">{localStorage.getItem('lang') == 'ru'? 'Пользование ':'Conditions'}<span className="footer__links--hidden">{localStorage.getItem('lang') == 'ru'? 'сайтом':' '}</span></NavLink>
            <div>&nbsp;</div>
            <div className="footer__name">{localStorage.getItem('lang') == 'ru'? 'Мы в сети':'We in social media'}</div>
            <a href="https://www.behance.net/leotrado8901" className="footer__links footer__links__shot" target="_blank" rel="noopener noreferrer">Behance</a>
            <a href="https://www.facebook.com/leotradocompani/" className="footer__links footer__links__shot" target="_blank" rel="noopener noreferrer">Facebook</a>
            {localStorage.getItem('lang') == 'ru'? <a href="https://vk.com/leotrado" className="footer__links footer__links__shot" target="_blank" rel="noopener noreferrer">Вконтакте</a>:''}
            </div>
            <div className="footer__content__contacts">
            <div className="footer__name">{localStorage.getItem('lang') == 'ru'? 'Контакты':'Contacts'}</div>
            {localStorage.getItem('lang') == 'ru'? <a href="tel: +7 903 406 64 99" className="footer__link-contacts">+7(903)406-64-99</a>:<a href="tel: +1 (818) 851-1502" className="footer__link-contacts">+1 (818) 851-1502</a>}
            <a href="mailto:pm@leotrado.com" className="footer__link-contacts">pm@leotrado.com</a>
    </div>
      </div>
    </div>
    <div className="footer__development">
      © 2020 leo trado development
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/footer/index.jsx